import Cookie from 'js-cookie'

import { LANGUAGE_COOKIE, NAVIGATOR_LANGUAGE_MAP } from './constants'

import { Language } from 'common/types'
import { User } from 'modules/auth/types'
import i18n from 'core/config/i18n'

class LanguageHelper {
  static defaultLanguage = Language.EN

  static getSupportedLanguage = (language?: string): Language | undefined => {
    const key = language?.substring(0, 2).toLowerCase() || ''

    return NAVIGATOR_LANGUAGE_MAP[key] || void 0
  }

  static get navigatorLanguage() {
    return LanguageHelper.getSupportedLanguage(navigator.language)
  }

  static get cookieLanguage() {
    return LanguageHelper.getSupportedLanguage(Cookie.get(LANGUAGE_COOKIE))
  }

  static getUserLanguage(user: User) {
    return LanguageHelper.getSupportedLanguage(user.locale)
  }

  static get currentLanguage() {
    return (i18n.language || Language.EN) as Language
  }
}

export default LanguageHelper
